import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSuitcaseTag20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSuitcaseTag20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.9 2.5h2.2a1 1 0 0 1 1 1V5H7.9V3.5a1 1 0 0 1 1-1M6.4 5V3.5A2.5 2.5 0 0 1 8.9 1h2.2a2.5 2.5 0 0 1 2.5 2.5V5h2.9A2.5 2.5 0 0 1 19 7.5v8a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 1 15.5v-8A2.5 2.5 0 0 1 3.5 5zm7.2 1.5h-.1v10h3a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1zm-1.6 0H8V8h.5a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8v3.5h4zm-5.5 10V13H6a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2h.5V6.5h-3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1zm-.5-7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2.5A.5.5 0 0 0 9 11v-1a.5.5 0 0 0-.5-.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSuitcaseTag20);
